import InfoIcon from '@mui/icons-material/Info';
import { IconButton } from "@mui/material"

interface ShowInfoButtonProps {
    onClick: () => void;
}


const iconButtonStyle = {
    color: "#666 !important",
    "&:hover": { color: "#000 !important", cursor: "pointer" }
}


export const ShowInfoButton = (props: ShowInfoButtonProps) => {

    return (
        <IconButton
            aria-label="settings"
            title="info"
            onClick={props.onClick}
            sx={iconButtonStyle}
            color="secondary"
        >
            <InfoIcon />
        </IconButton >
    )
}